import React from "react";

const Login = React.lazy(() => import("./App/pages/Auth/Login"));
const Signup = React.lazy(() => import("./App/pages/Auth/Signup"));
const ForgotPassword = React.lazy(() =>
  import("./App/pages/Auth/ForgotPassword")
);
const ResetPassword = React.lazy(() =>
  import("./App/pages/Auth/ResetPassword")
);
const Passcode = React.lazy(() => import("./App/pages/Auth/Passcode"));
const Welcome = React.lazy(() => import("./App/pages/Auth/Welcome"));
const SelectCategory = React.lazy(() =>
  import("./App/pages/Auth/SelectCategory")
);
const CreateGroup = React.lazy(() => import("./App/pages/Auth/CreateGroup"));
const SubscriptionPlans = React.lazy(() =>
  import("./App/pages/Auth/SubscriptionPlans")
);
const PurchasePlan = React.lazy(() => import("./App/pages/Auth/PurchasePlan"));
const TrialExpired = React.lazy(() => import("./App/pages/Auth/TrialExpired"));
const CompleteProfile = React.lazy(() =>
  import("./App/pages/Auth/CompleteProfile")
);
const PillarSettings = React.lazy(() =>
  import("./App/pages/Auth/PillarSettings")
);

const Team = React.lazy(() => import("./App/pages/Tools/Content/Team"));
// const CSED = React.lazy(() => import("./App/pages/Tools/Content/CSED"));
// const CCMS = React.lazy(() => import("./App/pages/Tools/Content/CCMS"));
// const LocksAndKeys = React.lazy(() =>
//   import("./App/pages/Tools/Content/LocksAndKeys")
// );
// const FourWheelsOfSuccess = React.lazy(() =>
//   import("./App/pages/Tools/Content/FourWheelsOfSuccess")
// );
const DynamicTools = React.lazy(() => import("./App/pages/Tools/DynamicTools"));


const LessonDetailsPublic = React.lazy(() =>
  import("./App/pages/Lesson/LessonDetailsPublic")
);

const InspirationDetailsPublic = React.lazy(() =>
  import("./App/pages/Inspiration/InspirationDetailsPublic")
);

const QuoteDetailsPublic = React.lazy(() =>
  import("./App/pages/Quote/QuoteDetailsPublic")
);

const route = [
  { path: "/auth/login", exact: true, component: Login },
  { path: "/auth/signup", exact: true, component: Signup },
  { path: "/auth/forgot-password", exact: true, component: ForgotPassword },
  {
    path: "/auth/reset-password/:token",
    exact: true,
    component: ResetPassword,
  },
  { path: "/auth/passcode", exact: true, component: Passcode },
  { path: "/auth/welcome", exact: true, component: Welcome },
  { path: "/auth/select-category", exact: true, component: SelectCategory },
  { path: "/auth/create-group", exact: true, component: CreateGroup },
  {
    path: "/auth/subscription-plans",
    exact: true,
    component: SubscriptionPlans,
  },
  {
    path: "/auth/purchase-plan",
    exact: true,
    component: PurchasePlan,
  },
  {
    path: "/auth/trial-expired",
    exact: true,
    component: TrialExpired,
  },
  {
    path: "/auth/complete-profile",
    exact: true,
    component: CompleteProfile,
  },
  {
    path: "/auth/pillar-settings",
    exact: true,
    component: PillarSettings,
  },
  {
    path: "/pages/team",
    exact: true,
    component: Team,
  },
  {
    path: "/pages/:slugId",
    exact: true,
    component: DynamicTools,
  },
  // {
  //   path: "/pages/csed",
  //   exact: true,
  //   component: CSED,
  // },
  // {
  //   path: "/pages/ccms",
  //   exact: true,
  //   component: CCMS,
  // },
  // {
  //   path: "/pages/locks-keys",
  //   exact: true,
  //   component: LocksAndKeys,
  // },
  // {
  //   path: "/pages/four-wheels",
  //   exact: true,
  //   component: FourWheelsOfSuccess,
  // },
  {
    path: "/lesson/:lessonId",
    exact: true,
    component: LessonDetailsPublic,
  },
  {
    path: "/inspiration/:behaviourId",
    exact: true,
    component: InspirationDetailsPublic,
  },
  {
    path: "/quote/:quoteId",
    exact: true,
    component: QuoteDetailsPublic,
  },
];

export default route;
